import { render, staticRenderFns } from "./EmailBar.vue?vue&type=template&id=10aa6947&scoped=true&"
import script from "./EmailBar.vue?vue&type=script&lang=js&"
export * from "./EmailBar.vue?vue&type=script&lang=js&"
import style0 from "./EmailBar.vue?vue&type=style&index=0&id=10aa6947&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aa6947",
  null
  
)

export default component.exports